import { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Motion, presets } from '../motion';

const inp = { background: '#0d0d0d', border: '1px solid #2a2a2a', borderRadius: '12px', padding: '13px 16px', color: '#f0f0f0', fontFamily: 'inherit', fontSize: '14px', outline: 'none', width: '100%', boxSizing: 'border-box' };

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    if (password !== confirm) return setError('Passwords do not match.');
    setLoading(true);
    setError('');
    try {
      await axios.post('/api/auth/reset-password', { token, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid or expired link.');
    }
    setLoading(false);
  };

  const wrap = { minHeight: '100vh', background: '#000', padding: '40px 24px', fontFamily: "'Plus Jakarta Sans', sans-serif" };
  const logo = { fontFamily: 'Nunito', fontSize: '36px', fontWeight: 900, letterSpacing: '3px', color: '#9b5de5', marginBottom: '8px' };

  if (!token) {
    return (
      <Motion {...presets.rise} style={wrap}>
        <div style={logo}>BLOBL</div>
        <p style={{ color: '#f43f5e', marginBottom: '16px' }}>Invalid reset link.</p>
        <Link to="/login" style={{ color: '#c084fc', fontSize: '14px', textDecoration: 'none' }}>Back to login</Link>
      </Motion>
    );
  }

  return (
    <Motion {...presets.rise} style={wrap}>
      <div style={logo}>BLOBL</div>
      <p style={{ color: '#555', marginBottom: '32px' }}>Choose a new password</p>

      {done ? (
        <div style={{ background: 'rgba(155,93,229,0.08)', border: '1px solid rgba(155,93,229,0.2)', borderRadius: '12px', padding: '18px 20px', color: '#c084fc', fontSize: '14px', lineHeight: 1.6 }}>
          Password updated! Redirecting to login…
        </div>
      ) : (
        <>
          {error && (
            <div style={{ color: '#f43f5e', marginBottom: '16px', fontSize: '13px', background: 'rgba(244,63,94,0.08)', border: '1px solid rgba(244,63,94,0.2)', borderRadius: '10px', padding: '10px 14px' }}>
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <input
              type="password"
              placeholder="New password (min. 8 characters)"
              value={password}
              onChange={e => { setPassword(e.target.value); setError(''); }}
              required
              style={inp}
            />
            <input
              type="password"
              placeholder="Confirm new password"
              value={confirm}
              onChange={e => { setConfirm(e.target.value); setError(''); }}
              required
              style={inp}
            />
            <button
              type="submit"
              disabled={loading}
              style={{ background: 'linear-gradient(135deg, #9b5de5, #7c3aed)', border: 'none', borderRadius: '25px', padding: '14px', color: 'white', fontFamily: 'Nunito', fontSize: '14px', fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
            >
              {loading ? 'Saving…' : 'Set new password'}
            </button>
          </form>
        </>
      )}

      <p style={{ marginTop: '24px', textAlign: 'center', fontSize: '14px' }}>
        <Link to="/login" style={{ color: '#c084fc', textDecoration: 'none' }}>Back to login</Link>
      </p>
    </Motion>
  );
}
